import { useState, useEffect } from 'react';
import Swiper, { Navigation, Keyboard, Pagination } from 'swiper';

function useNewsAndInsights(props) {

  const dataLabels = JSON.parse(props.labels);
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [firstLoad, setFirstLoad] = useState(false);

  const [webinarsData, setWebinarsData] = useState([]);
  const [newsData, setNewsData] = useState([]);
  const [blogsData, setBlogsData] = useState([]);
  const [resourcesData, setResourcesData] = useState([]);
  const [seeAllData, setSeeAllData] = useState([]);
  const [activeDataGroup, setActiveDataGroup] = useState([]);

  const [showWebinars, setShowWebinars] = useState(false);
  const [showNews, setShowNews] = useState(false);
  const [showBlogs, setShowBlogs] = useState(false);
  const [showResources, setShowResources] = useState(false);
  const [showSeeAll, setShowSeeAll] = useState(false);

  const [mobileActiveTabText, setMobileActiveTabText] = useState(
    (dataLabels && dataLabels.seeAll) ? dataLabels.seeAll : 'See All'
  );

  const [mobileActiveTabId, setMobileActiveTabId] = useState('seeAll');
    const [mobileFilterExpanded, setMobileFilterExpanded] = useState(false);

  


  const processData = data => {   
   // get the webinars from data:
    const webinars = data.filter(item => item.type === 'Webinars');
    setWebinarsData(webinars);
    // get the news from data:
    const news = data.filter(item => item.type === 'News');
    setNewsData(news);
    // get the blogs from data:
    const blogs = data.filter(item => item.type === 'Blog');
    setBlogsData(blogs);
    // get the resources from data:
    const resources = data.filter(item => item.type === 'Resources');
    setResourcesData(resources);
    // get the lastest item from webinars, the latest item from news, the latest item from blogs, the latest item from resources; order them by date and set them to seeAll
    let lastPerEachCategory = [
      webinars.sort((a, b) => new Date(b.date) - new Date(a.date))[0],
      news.sort((a, b) => new Date(b.date) - new Date(a.date))[0],
      blogs.sort((a, b) => new Date(b.date) - new Date(a.date))[0],
      resources.sort((a, b) => new Date(b.date) - new Date(a.date))[0]
    ];
    lastPerEachCategory = lastPerEachCategory.sort((a, b) => new Date(b.date) - new Date(a.date));
    setSeeAllData(lastPerEachCategory);
  }

  const fetchData = () => {
    const endpoint = new URL(`${props.endpoint}`, window.location.origin);
    setIsLoading(true);

    window
      .fetch(endpoint.toString(), {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(r => r.json())
      .then(data => {
        if (data.results) {
          processData(data.results);
        } else {
          setError(true);
        }
        setIsLoading(false);
        if (!firstLoad) {
          setFirstLoad(true);
        }
      })
      .catch(() => {
        // setError(e);
        setError(true);
        setIsLoading(false);
        if (!firstLoad) {
          setFirstLoad(true);
        }
      });
  };

  const init = () => {
    fetchData();
  };


  const createSwiper = () => {
    Swiper.use([Keyboard, Pagination, Navigation]);
    new Swiper('.content-cards__container', {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      watchOverflow: true,
      resizeObserver: true,
      centeredSlides: true,
      direction: 'horizontal',
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      autoHeight: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        type: 'custom',
        renderCustom (swiper, current, total) {   
          let out = ''
          for (let i = 1; i < total+1; i++) {
            if (i === current) {
              out = `${out  }<button class="swiper-pagination-bullet swiper-pagination-bullet-active" aria-label="Go to slide ${i}"></button>`;
            }
            else {
              out = `${out  }<button class="swiper-pagination-bullet" aria-label="Go to slide ${i}"></button>`;
            }
          };
          return out;
        },
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          centeredSlides: false,
          autoHeight: true,
        },
        1024: {
          slidesPerView: 3,
          centeredSlides: false,
          autoHeight: true,
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  const handleSelectClick = (isActive) => {
    if (isActive) {
      setMobileFilterExpanded(false);
    } else {
      setMobileFilterExpanded(true);
    }
  }

  const handleToggleTabs = (tab) => {
    const swiperContainer = document.querySelector('.content-cards__container');
    if (swiperContainer) {
      swiperContainer.swiper.destroy();
    }

    const tabCleaned = tab.toLowerCase().replace(' ', '');

    setShowWebinars(false);
    setShowNews(false);
    setShowBlogs(false);
    setShowResources(false);
    setShowSeeAll(false);

    let activeGroup;
    switch (tabCleaned) {
      case 'webinars':
        activeGroup = webinarsData;
        setShowWebinars(true);
        setMobileActiveTabId('webinars');
        setMobileActiveTabText((dataLabels && dataLabels.webinars) ? dataLabels.webinars : 'Webinars');
        break;
      case 'news':
        activeGroup = newsData;
        setShowNews(true);
        setMobileActiveTabId('news');
        setMobileActiveTabText((dataLabels && dataLabels.news) ? dataLabels.news : 'News');
        break;
      case 'blogs':
        activeGroup = blogsData;
        setShowBlogs(true);
        setMobileActiveTabId('blogs');
        setMobileActiveTabText((dataLabels && dataLabels.blogs) ? dataLabels.blogs : 'Blogs');
        break;
      case 'resources':
        activeGroup = resourcesData;
        setShowResources(true);
        setMobileActiveTabId('resources');
        setMobileActiveTabText((dataLabels && dataLabels.resources) ? dataLabels.resources : 'Resources');
        break;
      default:
        activeGroup = seeAllData;
        setShowSeeAll(true);
        setMobileActiveTabId('seeAll');
        setMobileActiveTabText((dataLabels && dataLabels.seeAll) ? dataLabels.seeAll : 'See All');
    }
    setActiveDataGroup(activeGroup);
  }

  useEffect(init, []);

  useEffect(() => {
    if (firstLoad) {
      setActiveDataGroup(seeAllData);
      setShowSeeAll(true);
    }
  }, [firstLoad]);

  const resultsData = {
    webinarsData,
    newsData,
    blogsData,
    resourcesData,
    seeAllData
  };

  return {
    isLoading,
    error,
    resultsData,
    handleToggleTabs,
    handleSelectClick,
    activeDataGroup,
    createSwiper,
    showWebinars,
    showNews,
    showBlogs,
    showResources,
    showSeeAll,
    mobileActiveTabId,
    mobileActiveTabText,
    mobileFilterExpanded
    // renderSwiperWithGroupData
  };
}

export default useNewsAndInsights;
